module.exports = __webpack_public_path__ + "img/1549236900.6aeee384.jpg";